<main class="main">
  @if (isAuthenticated()) {
  <app-main-menu class="main-menu">
  </app-main-menu>
  }

  <div class="view">
    <router-outlet />
  </div>
</main>